import { z } from 'zod';

import { ShotLoad } from '../../statistics';
import { CourtArea } from '../court-area';

export type PlayerReportUiState = z.output<typeof playerReportUiStateSchema>;
export type PlayerReportUiStateDTO = z.input<typeof playerReportUiStateSchema>;

export const playerReportUiStateSchema = z.object({
  performanceTrends: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
  playerProfile: z
    .object({
      expanded: z.boolean().catch(true),
    })
    .catch({
      expanded: true,
    }),
  shotAreas: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
      selectedAreas: z.array(z.enum(CourtArea)).catch([]),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
      selectedAreas: [],
    }),
  shotLoad: z
    .object({
      expanded: z.boolean().catch(true),
      selectedAreaMap: z.enum(['fgp', 'distr', 'xvalue']).catch('fgp'),
      selectedShotLoad: z.enum(ShotLoad).catch(ShotLoad.HIGH),
    })
    .catch({
      expanded: true,
      selectedAreaMap: 'fgp',
      selectedShotLoad: ShotLoad.HIGH,
    }),
  shotTrends: z
    .object({
      expanded: z.boolean().catch(true),
      selectedMetric: z.enum(['fgp', 'twopp', 'threepp', 'efgp', 'ftp']).catch('fgp'),
    })
    .catch({
      expanded: true,
      selectedMetric: 'fgp',
    }),
});
